import { UploadValidationRulesObject } from './Form.types';
import { useProfile } from 'src/models';

export const MAX_SINGLE_FILE_SIZE = Math.pow(1024, 3) * 10; // 10GB

const useUploadMiddleware = (): UploadValidationRulesObject => {
  const profile = useProfile();

  return profile.hasActiveSubscriptions
    ? {
        maxSize: {
          value: MAX_SINGLE_FILE_SIZE,
          message:
            'Single file uploads are limited to 10 GB. For larger files, use an external link option below or contact support for custom workflows.',
        },
      }
    : {
        maxItems: {
          value: 10,
          message: "You'll need to have an active subscription to upload more than 10 files",
        },
        maxSize: {
          value: Math.pow(1024, 3),
          message:
            "You'll need to have an active subscription for uploading larger than 1 GB files",
        },
        maxGroupSize: {
          value: MAX_SINGLE_FILE_SIZE,
          message:
            'Your current plan allows up to 10GB of total file uploads per request. To continue uploading files, please upgrade to an active subscription, which provides an increased storage limit.',
        },
      };
};

export { useUploadMiddleware };
